import { money } from '../../core/format/currency'
import { changeOf, share, type Change } from '../../core/rules/insights/stats'
import type { Comparable } from '../../core/types/insights'

/**
 * Opmaak voor Inzicht. Wat er (nog) niet is, wordt "–", nooit 0.
 */

export const DASH = '–'

const nf = new Intl.NumberFormat('nl-NL')
const nf1 = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 1 })

export type ValueKind = 'money' | 'number' | 'decimal' | 'pct'

export function fmt(value: number | null | undefined, kind: ValueKind = 'number'): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return DASH
  switch (kind) {
    case 'money':
      return money(value)
    case 'decimal':
      return nf1.format(value)
    case 'pct':
      return `${nf1.format(value)}%`
    default:
      return nf.format(value)
  }
}

/** "42%" bij genoeg, anders "3 van 4": kleine aantallen worden geen grote percentages. */
export function ratio(part: number | null, whole: number | null, min?: number): string {
  if (part === null || whole === null || whole === 0) return DASH
  const pct = share(part, whole, min)
  return pct === null ? `${nf.format(part)} van ${nf.format(whole)}` : `${pct}%`
}

/** Het verschil met de vorige periode als tekst, met richting. `null` als het onbekend is. */
export function changeLabel(value: Comparable, kind: ValueKind): { text: string; up: boolean; flat: boolean } | null {
  // Bedragen zijn nooit "te klein" voor een percentage; aantallen en kommagetallen wel.
  const c: Change = changeOf(value, kind === 'money' ? 0 : kind === 'decimal' ? 1 : undefined)
  if (c.kind === 'unknown') return null
  const n = c.kind === 'percent' ? c.pct : c.diff
  const sign = n > 0 ? '+' : n < 0 ? '−' : '±'
  const abs = Math.abs(n)
  const text = c.kind === 'percent' ? `${sign}${abs}%` : `${sign}${kind === 'money' ? money(abs) : kind === 'decimal' ? nf1.format(abs) : nf.format(abs)}`
  return { text, up: n > 0, flat: n === 0 }
}
